import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import ResizeHook from '../Components/Hooks/ResizeHook';
import { Outlet } from 'react-router-dom';

const Layout = () => {

    const widthResize = ResizeHook();

    return (
        <>
            <Header />
            {widthResize > 991 && <Sidebar />}
            <main className="maincontent">
                <Outlet />
            </main>
            <Footer />
        </>
    )
}

export default Layout;